import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-date.svg'
import _imports_1 from '@/assets/images/banner_livestream.png'
import _imports_2 from '@/assets/images/banner_kemoclub.png'
import _imports_3 from '@/assets/images/bg-top_vrjmof.jpg'
import _imports_4 from '@/assets/images/top_conbadge.jpg'
import _imports_5 from '@/assets/images/logo-vrchat_ex.png'


const _withScopeId = n => (_pushScopeId("data-v-060caa76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents contents-top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "logo-date" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "2021.01.07 - 2021.01.10"
  })
], -1))
const _hoisted_3 = { class: "banner-link-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-link" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.twitch.tv/vr_jmof/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "公式動画配信",
      width: "300"
    })
  ])
], -1))
const _hoisted_5 = { class: "banner-link" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "VR JMoF × KEMO CLUB 開催決定！",
  width: "300"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "news-inner" }
const _hoisted_9 = {
  href: "https://www.v-market.work/v5/",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "page-flexwrap" }
const _hoisted_17 = { class: "page-image" }
const _hoisted_18 = ["alt"]
const _hoisted_19 = { class: "page-flexinner" }
const _hoisted_20 = {
  href: "https://twitter.com/Warningblackdog",
  target: "_blank"
}
const _hoisted_21 = { class: "caution" }
const _hoisted_22 = { class: "contents contents-about_VRChat" }
const _hoisted_23 = { class: "box-wrap" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "VRChat",
  width: "245",
  height: "137.5"
}, null, -1))
const _hoisted_25 = { class: "box-inner" }
const _hoisted_26 = { class: "contents contents-about_JMoF" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheTopLogo = _resolveComponent("TheTopLogo")!
  const _component_ContentBox = _resolveComponent("ContentBox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_LinkButton = _resolveComponent("LinkButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_TheTopLogo),
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/program#kemo_club_1" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_ContentBox, { class: "content-box box-news" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news_title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_5')), 1),
              _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_5')), 1)
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_4')), 1),
              _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_4')), 1)
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_3')), 1),
              _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('dd_3')), 1)
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_2')), 1),
              _createElementVNode("dd", null, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_2_1')) + " ", 1),
                _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$props.i18n.$text('link_8')), 1),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_2_2')), 1),
                _hoisted_10,
                _createVNode(_component_router_link, { to: "/program" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_9')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_2_3')), 1),
                _createVNode(_component_router_link, { to: "/program/schedule" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_10')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_2_4')), 1),
                _hoisted_11,
                _createVNode(_component_router_link, { to: "/access" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_11')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('dd_2_5')), 1),
                _hoisted_12,
                _createVNode(_component_router_link, { to: "/program/apply_avatar_poster" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_4')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('dd_2_6')), 1)
              ])
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('dt_1')), 1),
              _createElementVNode("dd", null, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_1_1')), 1),
                _hoisted_13,
                _createVNode(_component_router_link, { to: "/program/apply_avatar_poster" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_4')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('dd_1_2')), 1),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('dd_1_3')) + " ", 1),
                _createVNode(_component_router_link, { to: "/faq_contact" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_5')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('period')), 1),
                _createVNode(_component_router_link, { to: "/terms" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_6')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('period')) + _toDisplayString(_ctx.$props.i18n.$text('dd_1_4')), 1),
                _createVNode(_component_router_link, { to: "/credit" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_7')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('dd_1_5')), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_4')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('p_7')) + " ", 1),
            _hoisted_15,
            _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('p_8')), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                src: _imports_4,
                alt: _ctx.$props.i18n.$text('alt_1'),
                width: "320"
              }, null, 8, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_9')), 1),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('p_10')), 1),
                _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$props.i18n.$text('link2_1')), 1)
              ]),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$props.i18n.$text('caution_1')), 1)
            ])
          ]),
          _createVNode(_component_LinkButton, {
            href: "/downloads/VRJMoF_ConBadge.zip",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link2_2')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_22, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_3')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_4')), 1)
            ])
          ]),
          _createVNode(_component_LinkButton, {
            href: "https://hello.vrchat.com/",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_2')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_26, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_5')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_6')), 1),
          _createVNode(_component_LinkButton, {
            href: "https://www.jmof.jp/",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_3')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}